import React from "react";
import { isEmpty } from "lodash";
// enums
import EViewType from "@/cms/enums/EViewType";
// utilities
import SanitizeHTMLString from "@/utilities/SanitizeHTMLString";
// types
import TLanguageVersionDetail from "@/cms/types/TLanguageVersionDetail";
import TLanguageVersionList from "@/cms/types/TLanguageVersionList";


type TRMDRTextSanitizer = {

    parentLanguageVersion?: TLanguageVersionList|TLanguageVersionDetail|null;
    languageVersions?: TLanguageVersionList[]|TLanguageVersionDetail[]|null;

    isLoading?:boolean;

}

const RMDRTextSanitizer = ( props:TRMDRTextSanitizer ) => {

    if ( !isEmpty(props.parentLanguageVersion) && props.parentLanguageVersion?.viewType === EViewType.TEXT ) {

        return (
            <div className="ck-content" dangerouslySetInnerHTML={{ __html: SanitizeHTMLString(props.parentLanguageVersion.value)}} />
        );

    }

    return null;

}

export default RMDRTextSanitizer;
export type {
    TRMDRTextSanitizer
};